/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./HoverableLink.vue?vue&type=template&id=a94b0d7a"
import script from "./HoverableLink.vue?vue&type=script&lang=js"
export * from "./HoverableLink.vue?vue&type=script&lang=js"
import style0 from "./HoverableLink.vue?vue&type=style&index=0&id=a94b0d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports